import React, { useEffect, useRef, useState, Fragment } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
// import DialogActions from '@mui/material/DialogActions';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ReactToPrint from "react-to-print";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
// import { Title } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 99999,
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    minWidth: "fit-content",
  },
}));

const DialogContentModal = ({ children, dataOpen, onClose, title }) => {
  const conponentPDF = useRef();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        // onClick={onClose}
        aria-labelledby="customized-dialog-title"
        open={dataOpen}
        fullWidth
        maxWidth={"lg"}
        style={{ minWidth: "fit-content" }}
      >
        <DialogTitle className="myapplication-dialog-title" id="customized-dialog-title">
          <div>
            <span style={{ marginRight: "8px" }}>{title}</span>
            <ReactToPrint
              trigger={() => (
                <button className="btn btn-success" id="invoice-print">
                  Print
                </button>
              )}
              content={() => conponentPDF.current}
            />
          </div>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              zIndex: 10,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <div ref={conponentPDF}>
          <DialogContent dividers>{children}</DialogContent>
        </div>
      </BootstrapDialog>
    </React.Fragment>
  );
};
export default DialogContentModal;
